import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useStyles } from "./NoData.styles";

export const NoData = () => {
    const { t } = useTranslation();
    const classes = useStyles();

    return (
        <Box className={classes.container}>
            <Typography variant="h1" className={classes.title}>
                {t("data.no_data")}
            </Typography>
        </Box>
    );
};
